import { Button, CircularProgress, Link, Typography } from "@mui/joy";
import { Box } from "@mui/material";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { getContrastYIQ } from "../helpers";
import { useGetPublicBookletQuery } from "../redux/booklet";
import { Helmet } from "react-helmet";

/**
 *
 * @returns {ReactElement} BookletPage page
 */
export function BookletPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  console.log(token);
  const { data } = useGetPublicBookletQuery(token ?? "", { skip: !token });

  if (!data)
    return (
      <Box
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <CircularProgress />
      </Box>
    );

  const company = data.company;
  const booklet = data.booklet;
  const color = getContrastYIQ(company?.color ?? "#000000");

  return (
    <Box
      sx={{
        background: company.color ? company.color : "rgb(2, 28, 51)",
        padding: "0.5rem",
      }}
    >
      <Helmet>
        <meta
          name="theme-color"
          content={company.color ? company.color : "rgb(2, 28, 51)"}
        />
        <title>{booklet?.name}</title>
      </Helmet>
      <Box
        sx={{
          display: "flex",
          maxWidth: "820px",
          margin: "auto",
          justifyContent: "space-between",
        }}
      >
        <img
          src={
            company?.logoURL ??
            "https://storage.googleapis.com/rhapsody/Avatars/rhapsody.png"
          }
          style={{ height: 45 }}
        />
        <Box sx={{ textAlign: "right" }}>
          <Button
            onClick={print}
            startDecorator={<i className="fa-solid fa-print"></i>}
            size="sm"
            color="neutral"
            sx={{ zIndex: 9999 }}
          >
            Print
          </Button>
          <Typography level="body-xs" sx={{ color, opacity: 0.58 }}>
            Updated {moment(booklet.updatedAt).format("lll")} (
            {moment(booklet.updatedAt).fromNow()})
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: "#fff",
          boxShadow: "0 0 4px rgba(0, 0, 0, 0.15)",
          boxSizing: "border-box",
          margin: "1rem auto 0",
          maxWidth: "820px",
          minHeight: "calc(100vh - 1rem)",
          padding: "0.635cm 1.27cm 0.635cm 1.27cm",
        }}
      >
        {booklet.active ? (
          <div
            className="mce-content-body"
            id="printableDiv"
            dangerouslySetInnerHTML={{
              __html: booklet.content,
            }}
          ></div>
        ) : (
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <Typography
              startDecorator={
                <i className="fa-solid fa-triangle-exclamation"></i>
              }
            >
              Content not active yet
            </Typography>
            <Typography level="body-sm">Please check again later</Typography>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
          color,
          pb: 8,
          pt: 2,
          opacity: 0.58,
          background: company?.color,
        }}
      >
        <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
          <Typography
            level="body-md"
            sx={{ color: "inherit" }}
            endDecorator={
              <img
                onClick={() => window.open("https://www.rhapsody.la")}
                src={"https://storage.googleapis.com/rhapsody/Avatars/logo.svg"}
                style={{
                  height: 25,
                  cursor: "pointer",
                }}
              />
            }
          >
            <b>
              <i>Powered by</i>
            </b>{" "}
          </Typography>
        </Box>
        <Typography level="body-xs" sx={{ color: "inherit", mt: 1 }}>
          Developed with love in Los Angeles, CA
          <br />
          <Link sx={{ color: "inherit" }} href="mailto:contact@rhapsody.la">
            contact@rhapsody.la
          </Link>
          <br />
          <Link sx={{ color: "inherit" }} href="https://www.rhapsody.la">
            www.rhapsody.la
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}

const booklet = {
  id: 15,
  organizationID: 1,
  name: "Pamphlet",
  description: "",
  mergeTag: "",
  snippet: false,
  author: "Olivier Kastel",
  content:
    '\u003cdiv\u003e\u003cspan style="font-family: \'courier new\', courier, monospace;"\u003e\u003cstrong\u003eProject Name:\u003c/strong\u003e \u003c!-- --\u003eProject\u003c/span\u003e\u003c/div\u003e\n\u003cdiv\u003e\u003cspan style="font-family: \'courier new\', courier, monospace;"\u003e\u003cstrong\u003eConductor\u003c!-- --\u003e:\u003c/strong\u003e \u003c!-- --\u003eGustavo Dudamel\u003c/span\u003e\u003c/div\u003e\n\u003cdiv\u003e\u003cspan style="font-family: \'courier new\', courier, monospace;"\u003e\u003cstrong\u003eLocation\u003c!-- --\u003es\u003c!-- --\u003e:\u003c/strong\u003e \u003c!-- --\u003eCapitol Records, 6132 Ellenview Avenue, Glee Studios\u003cstrong\u003eMax Count:\u003c/strong\u003e \u003c!-- --\u003e71\u003c!-- --\u003e Musician\u003c!-- --\u003es\u003c/span\u003e\u003cbr\u003e\u003cspan style="font-family: \'courier new\', courier, monospace;"\u003e\u003cstrong\u003eString Count:\u003c/strong\u003e \u003c!-- --\u003e12 vn1, 11 vn2, 8 va, 8 vc, 7 db\u003c/span\u003e\n\u003ch2\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eSchedule\u003c/span\u003e\u003c/h2\u003e\n\u003ctable style="border-collapse: collapse; border-style: solid;" border="1"\u003e\n\u003cthead style="text-align: left;"\u003e\n\u003ctr\u003e\n\u003cth\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eDate\u003c/span\u003e\u003c/th\u003e\n\u003cth\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eStart\u003c/span\u003e\u003c/th\u003e\n\u003cth\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eEnd\u003c/span\u003e\u003c/th\u003e\n\u003cth\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003ePlace\u003c/span\u003e\u003c/th\u003e\n\u003cth\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eRehearsal Order\u003c/span\u003e\u003c/th\u003e\n\u003c/tr\u003e\n\u003c/thead\u003e\n\u003ctbody\u003e\n\u003ctr\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eSaturday, March 15, 2025\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003e10:15 AM (PDT)\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003e11:45 AM (PDT)\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eCapitol Records\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\n\u003cul\u003e\n\u003cli style="font-family: \'comic sans ms\', sans-serif;"\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eAn American in Paris\u003c!-- --\u003e, \u003c!-- --\u003eGeorge Gershwin\u003c!-- --\u003e (\u003c!-- --\u003eStrings\u003c!-- --\u003e)\u003c/span\u003e\u003c/li\u003e\n\u003cli style="font-family: \'comic sans ms\', sans-serif;"\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eRhapsody In Blue\u003c!-- --\u003e, \u003c!-- --\u003eGeorge Gershwin\u003c!-- --\u003e (\u003c!-- --\u003eStrings\u003c!-- --\u003e)\u003c/span\u003e\u003c/li\u003e\n\u003c/ul\u003e\n\u003c/td\u003e\n\u003c/tr\u003e\n\u003ctr\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eSaturday, March 15, 2025\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003e12:00 PM (PDT)\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003e2:00 PM (PDT)\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003e6132 Ellenview Avenue\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\n\u003cul\u003e\n\u003cli style="font-family: \'comic sans ms\', sans-serif;"\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eRhapsody In Blue\u003c!-- --\u003e, \u003c!-- --\u003eGeorge Gershwin\u003c!-- --\u003e (\u003c!-- --\u003eTutti\u003c!-- --\u003e)\u003c/span\u003e\u003c/li\u003e\n\u003cli style="font-family: \'comic sans ms\', sans-serif;"\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eAn American in Paris\u003c!-- --\u003e, \u003c!-- --\u003eGeorge Gershwin\u003c!-- --\u003e (\u003c!-- --\u003eTutti\u003c!-- --\u003e)\u003c/span\u003e\u003c/li\u003e\n\u003c/ul\u003e\n\u003c/td\u003e\n\u003c/tr\u003e\n\u003ctr\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eSaturday, March 15, 2025\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003e2:30 PM (PDT)\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003e4:30 PM (PDT)\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eGlee Studios\u003c/span\u003e\u003c/td\u003e\n\u003ctd\u003e\n\u003cul\u003e\n\u003cli style="font-family: \'comic sans ms\', sans-serif;"\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eAn American in Paris\u003c!-- --\u003e, \u003c!-- --\u003eGeorge Gershwin\u003c!-- --\u003e (\u003c!-- --\u003eTutti\u003c!-- --\u003e)\u003c/span\u003e\u003c/li\u003e\n\u003cli style="font-family: \'comic sans ms\', sans-serif;"\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eRhapsody In Blue\u003c!-- --\u003e, \u003c!-- --\u003eGeorge Gershwin\u003c!-- --\u003e (\u003c!-- --\u003eTutti\u003c!-- --\u003e)\u003c/span\u003e\u003c/li\u003e\n\u003c/ul\u003e\n\u003c/td\u003e\n\u003c/tr\u003e\n\u003c/tbody\u003e\n\u003c/table\u003e\n\u003ch2\u003e\u003cspan style="font-family: \'comic sans ms\', sans-serif;"\u003eProgram\u003c/span\u003e\u003c/h2\u003e\n\u003ctable\u003e\n\u003cthead style="text-align: left;"\u003e\n\u003ctr\u003e\n\u003cth\u003eProgram\u003c/th\u003e\n\u003cth\u003eInstrumentation\u003c/th\u003e\n\u003cth\u003eTime\u003c/th\u003e\n\u003c/tr\u003e\n\u003c/thead\u003e\n\u003ctbody\u003e\n\u003ctr\u003e\n\u003ctd\u003eAn American in Paris, George Gershwin\u003c/td\u003e\n\u003ctd\u003e3[1.2.3/pic] 3[1.2.Eh] 3[1.2.bcl] 2 \u0026mdash; 4 3 3 1 \u0026mdash; asx, tsx, bsx \u0026mdash; tmp+4 \u0026mdash; cel \u0026mdash; str\u003c/td\u003e\n\u003ctd\u003e\u0026nbsp;\u003c/td\u003e\n\u003c/tr\u003e\n\u003ctr\u003e\n\u003ctd\u003eRhapsody In Blue, George Gershwin\u003c/td\u003e\n\u003ctd\u003e1 1 2 1 \u0026mdash; 2 2 1 0 \u0026mdash; 3sx[asx.tsx.asx] \u0026mdash; banjo \u0026mdash; tmp+2 \u0026mdash; str\u003c/td\u003e\n\u003ctd\u003e\u0026nbsp;\u003c/td\u003e\n\u003c/tr\u003e\n\u003c/tbody\u003e\n\u003c/table\u003e\n\u003ch2\u003eLinks\u003c/h2\u003e\n\u003ctable\u003e\n\u003cthead style="text-align: left;"\u003e\n\u003ctr\u003e\n\u003cth\u003eName\u003c/th\u003e\n\u003cth\u003eDescription\u003c/th\u003e\n\u003cth\u003eURL\u003c/th\u003e\n\u003c/tr\u003e\n\u003c/thead\u003e\n\u003ctbody\u003e\n\u003ctr\u003e\n\u003ctd\u003eViolins Changed\u003c/td\u003e\n\u003ctd\u003eParts\u003c/td\u003e\n\u003ctd\u003ehttps://www.google.fr\u003c/td\u003e\n\u003c/tr\u003e\n\u003c/tbody\u003e\n\u003c/table\u003e\n\u003ch2\u003eContacts\u003c/h2\u003e\n\u003ctable\u003e\n\u003cthead style="text-align: left;"\u003e\n\u003ctr\u003e\n\u003cth\u003eName\u003c/th\u003e\n\u003cth\u003eRole\u003c/th\u003e\n\u003cth\u003eContacts\u003c/th\u003e\n\u003c/tr\u003e\n\u003c/thead\u003e\n\u003ctbody\u003e\n\u003ctr\u003e\n\u003ctd\u003eSydney Adedamola\u003c/td\u003e\n\u003ctd\u003eLibrarian\u003c/td\u003e\n\u003ctd\u003esuydney@wid.la\u003c!-- --\u003e,\u003c/td\u003e\n\u003c/tr\u003e\n\u003ctr\u003e\n\u003ctd\u003eMaurice Andr\u0026eacute;\u003c/td\u003e\n\u003ctd\u003eContractor\u003c/td\u003e\n\u003ctd\u003eMaurice.Andre@ignore.it\u003c!-- --\u003e,\u003c/td\u003e\n\u003c/tr\u003e\n\u003ctr\u003e\n\u003ctd\u003eCarl Almenr\u0026auml;der\u003c/td\u003e\n\u003ctd\u003eBook\u003c/td\u003e\n\u003ctd\u003eCarl.Almenrader@ignore.it\u003c!-- --\u003e,\u003c/td\u003e\n\u003c/tr\u003e\n\u003c/tbody\u003e\n\u003c/table\u003e\n\u003ch2\u003eLive Rosters\u003c/h2\u003e\n\u003ctable\u003e\n\u003cthead style="text-align: left;"\u003e\n\u003ctr\u003e\n\u003cth\u003eName\u003c/th\u003e\n\u003cth\u003eURL\u003c/th\u003e\n\u003c/tr\u003e\n\u003c/thead\u003e\n\u003ctbody\u003e\n\u003ctr\u003e\n\u003ctd\u003eMain Roster\u003c/td\u003e\n\u003ctd\u003ehttps://roster.alpha.rhapsody.la?token=fOgOkPVkQFXChO6VCu\u003c/td\u003e\n\u003c/tr\u003e\n\u003c/tbody\u003e\n\u003c/table\u003e\n\u003cdiv\u003e\n\u003cp\u003e\u003cstrong\u003eOption A\u003c/strong\u003e: Long-sleeve, floor-length, formal, pressed, concert black suit or dress. Dress shoes (no boots or sandals) and no faded, casual cotton. Only small, black purses shall be permitted on stage.\u003c/p\u003e\n\u003cp\u003e\u003cstrong\u003eOption B\u003c/strong\u003e: Black suit, black button-down shirt, and long black tie, black dress shoes.\u003c/p\u003e\n\u003c/div\u003e\n\u003c/div\u003e',
  projectID: 1180,
  venueID: 0,
  musicianID: 0,
  tagID: 0,
  pieceID: 0,
  createdAt: "2025-03-16T00:39:52Z",
  updatedAt: "2025-03-18T21:13:39Z",
};
const company = {
  id: 149,
  contact: "Wayne Solomon",
  name: "Sacramento Philharmonic \u0026 Opera",
  email: "personnel@sacphilopera.org",
  address: "1110 2nd Street",
  city: "Sacramento",
  zipcode: "95814",
  state: "CA",
  phone: "+1 559 930 2663",
  initiated: false,
  referralCode: null,
  logoURL:
    "https://storage.googleapis.com/rhapsody_alpha/data-upload/315641b2-5de4-4e54-923e-1b305e004436/logo.svg",
  signatureURL: null,
  organizationID: 137,
  restricted: null,
  defaultTab: 0,
  userName: "SacPhilOpera",
  pipelineID: null,
  stripeCustomerID: "cus_NwZCmVqmTNElYo",
  color: "#67288f",
  icon: "",
  enableRelease: false,
  defaultProjectVersion: 1,
  settings: "",
  musicianID: null,
  active: null,
  trusted: null,
  pipelines: null,
};
